import { FaShower, FaParking,FaSun, FaWifi, FaCoffee, FaSwimmer, FaDumbbell, FaSpa, FaLock, FaBicycle, FaKey, FaCamera, FaFireExtinguisher, FaDog, FaAccessibleIcon, FaFirstAid, FaClock, FaChargingStation, FaBook, FaGamepad, FaBasketballBall, FaFootballBall, FaRunning, FaProjectDiagram, FaMusic, FaLightbulb, FaTrophy, FaFlagCheckered, FaStoreAlt, FaUsers, FaFileInvoice,FaHome } from 'react-icons/fa';
import { GiBarbecue,GiVideoConference,GiGrass,GiArcheryTarget} from 'react-icons/gi';
import { MdElevator , MdOutlineSportsTennis} from "react-icons/md";
import { IoTicket } from "react-icons/io5";

import { FaHotTub } from "react-icons/fa";
import { TbMoodKidFilled } from "react-icons/tb";


const amenitiesWithIcons = [
  { value: 'Shower', label: 'Shower', icon: <FaShower /> },
  { value: 'Locker Room', label: 'Locker Room', icon: <FaLock /> },
  { value: 'Parking', label: 'Parking', icon: <FaParking /> },
  { value: 'WiFi', label: 'WiFi', icon: <FaWifi /> },
  { value: 'Cafeteria', label: 'Cafeteria', icon: <FaCoffee /> },
  { value: 'Restrooms', label: 'Restrooms', icon: <FaLock /> },
  { value: 'Swimming Pool', label: 'Swimming Pool', icon: <FaSwimmer /> },
  { value: 'Air Conditioning', label: 'Air Conditioning', icon: <FaDumbbell /> },
  { value: 'Gym', label: 'Gym', icon: <FaDumbbell /> },
  { value: 'Sauna', label: 'Sauna', icon: <FaHotTub /> },
  { value: 'Spa', label: 'Spa', icon: <FaSpa /> },
  { value: 'Laundry Service', label: 'Laundry Service', icon: <FaLock /> },
  { value: 'Security Cameras', label: 'Security Cameras', icon: <FaCamera /> },
  { value: 'Fire Extinguisher', label: 'Fire Extinguisher', icon: <FaFireExtinguisher /> },
  { value: 'Barbecue Area', label: 'Barbecue Area', icon: <GiBarbecue /> },
  { value: 'Playground', label: 'Playground', icon: <GiGrass /> },
  { value: 'Pet Friendly', label: 'Pet Friendly', icon: <FaDog /> },
  { value: 'ATM', label: 'ATM', icon: <FaKey /> },
  { value: '24-Hour Access', label: '24-Hour Access', icon: <FaClock /> },
  { value: 'Elevator', label: 'Elevator', icon: <MdElevator /> },
  { value: 'Wheelchair Accessible', label: 'Wheelchair Accessible', icon: <FaAccessibleIcon /> },
  { value: 'First Aid', label: 'First Aid', icon: <FaFirstAid /> },
  { value: 'Sports Equipment Rental', label: 'Sports Equipment Rental', icon: <FaKey /> },
  { value: 'Bicycle Rack', label: 'Bicycle Rack', icon: <FaBicycle /> },
  { value: 'Charging Stations', label: 'Charging Stations', icon: <FaChargingStation /> },
  { value: 'Conference Rooms', label: 'Conference Rooms', icon: <GiVideoConference /> },
  { value: 'Private Lockers', label: 'Private Lockers', icon: <FaLock /> },
  { value: 'Vending Machines', label: 'Vending Machines', icon: <FaLock /> },
  { value: 'Gaming Zone', label: 'Gaming Zone', icon: <FaGamepad /> },
  { value: 'Kids Area', label: 'Kids Area', icon: <TbMoodKidFilled /> },
  { value: 'Valet Parking', label: 'Valet Parking', icon: <FaParking /> },
  { value: 'Laundry Room', label: 'Laundry Room', icon: <FaLock /> },
  { value: 'Lounge', label: 'Lounge', icon: <FaHome /> },
  { value: 'Garden', label: 'Garden', icon: <FaHome /> },
  { value: 'Sun Deck', label: 'Sun Deck', icon: <FaSun /> },
  { value: 'Library', label: 'Library', icon: <FaBook /> },
  { value: 'Movie Theater', label: 'Movie Theater', icon: <IoTicket /> },
  { value: 'Yoga Studio', label: 'Yoga Studio', icon: <FaDumbbell /> },
  { value: 'CCTV Surveillance', label: 'CCTV Surveillance', icon: <FaCamera /> },
  { value: 'Basketball Court', label: 'Basketball Court', icon: <FaBasketballBall /> },
  { value: 'Tennis Court', label: 'Tennis Court', icon: <MdOutlineSportsTennis /> },
  { value: 'Football Field', label: 'Football Field', icon: <FaFootballBall /> },
  { value: 'Badminton Court', label: 'Badminton Court', icon: < MdOutlineSportsTennis /> },
  { value: 'Cricket Pitch', label: 'Cricket Pitch', icon: <FaGamepad /> },
  { value: 'Archery Range', label: 'Archery Range', icon: <GiArcheryTarget /> },
  { value: 'Running Track', label: 'Running Track', icon: <FaRunning /> },
  { value: 'Skating Rink', label: 'Skating Rink', icon: <FaGamepad /> },
  { value: 'Boating Dock', label: 'Boating Dock', icon: <FaFlagCheckered /> },
  { value: 'Massage Room', label: 'Massage Room', icon: <FaSpa /> },
  { value: 'Changing Rooms', label: 'Changing Rooms', icon: <FaKey /> },
  { value: 'Medical Assistance', label: 'Medical Assistance', icon: <FaFirstAid /> },
  { value: 'Bike Rentals', label: 'Bike Rentals', icon: <FaBicycle /> },
  { value: 'Water Fountain', label: 'Water Fountain', icon: <FaLock /> },
  { value: 'Event Stage', label: 'Event Stage', icon: <FaFlagCheckered /> },
  { value: 'Projector', label: 'Projector', icon: <FaProjectDiagram /> },
  { value: 'Sound System', label: 'Sound System', icon: <FaMusic /> },
  { value: 'Lighting System', label: 'Lighting System', icon: <FaLightbulb /> },
  { value: 'Race Timing System', label: 'Race Timing System', icon: <FaTrophy /> },
  { value: 'Food Stalls', label: 'Food Stalls', icon: <FaStoreAlt /> },
  { value: 'Merchandise Stalls', label: 'Merchandise Stalls', icon: <FaStoreAlt /> },
  { value: 'Ticket Booths', label: 'Ticket Booths', icon: <IoTicket /> },
  { value: 'Media Area', label: 'Media Area', icon: <FaUsers /> },
  { value: 'VIP Lounge', label: 'VIP Lounge', icon: <FaLock /> },
  { value: 'Press Conference Room', label: 'Press Conference Room', icon: <GiVideoConference /> },
  { value: 'Medical Tent', label: 'Medical Tent', icon: <FaFirstAid /> },
  { value: 'Participant Registration Desk', label: 'Participant Registration Desk', icon: <FaFileInvoice /> },
  { value: 'Spectator Seating', label: 'Spectator Seating', icon: <FaUsers /> },
  { value: 'Race Track', label: 'Race Track', icon: <FaRunning /> },
  { value: 'Finish Line', label: 'Finish Line', icon: <FaFlagCheckered /> },
  { value: 'Cycling Racks', label: 'Cycling Racks', icon: <FaBicycle /> },
  { value: 'Amphitheater', label: 'Amphitheater', icon: <FaUsers /> },
  { value: 'Parking Assistance', label: 'Parking Assistance', icon: <FaParking /> },
  { value: 'On-Site Staff', label: 'On-Site Staff', icon: <FaUsers /> },
  { value: 'Live Scoreboard', label: 'Live Scoreboard', icon: <FaTrophy /> },
  { value: 'Paddle Boats', label: 'Paddle Boats', icon: <FaFlagCheckered /> },
  { value: 'Inflatable Games', label: 'Inflatable Games', icon: <FaGamepad /> },
  { value: 'Event Signage', label: 'Event Signage', icon: <FaFlagCheckered /> },
  { value: 'Souvenir Shops', label: 'Souvenir Shops', icon: <FaStoreAlt /> }
];

export default amenitiesWithIcons;
